import React, { useState } from "react";
import styles from "./styles.scss";

const ConsentModal = ({ open, onAgree }) => {
    const [checked, setChecked] = useState(false);

    const handleAgree = () => {
        setChecked(false);
        onAgree();
    };

    if (!open) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.header}>
                    <label className={styles.headerCheckLabel}>
                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) => setChecked(e.target.checked)}
                        />
                        <span>
                            <strong>개인[신용]정보 수집, 이용동의서[필수]</strong>
                            <em>안면인식 본인 확인용</em>
                        </span>
                    </label>
                </div>

                <div className={styles.body}>
                    <p className={styles.intro}>[롯데오토리스 귀중]</p>

                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>수집·이용 목적</div>
                        <div className={styles.sectionContent}>안면 인식을 통한 본인 확인</div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>보유 및 이용기간</div>
                        <div className={styles.sectionContent}>
                            거래 종료일로부터 5년<br/>
                            (단, 다른 관련 법령에 해당하는 경우 해당 법령상의 보존 기간을 따름)
                        </div>
                        <div className={styles.sectionSub}>
                            ※ 위 보유 기간에서의 거래 종료일이란 "회원탈퇴 또는 채권·채무 관계가 소멸된 날"을 말한다.
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>거부 권리 및 불이익</div>
                        <div className={styles.sectionContent}>
                            귀하는 아래의 개인(신용)정보 수집·이용에 관한 동의를 거부하실 수 있습니다.
                            다만, 개인(신용)정보 수집·이용에 관한 동의는 "안면인식 본인확인" 이용을 위한
                            필수적 사항이므로, 위 사항에 동의하셔야만 안면인식 본인 확인이 가능합니다.
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>수집·이용 항목</div>
                        <div className={styles.sectionContent}>
                            민감정보 : 신분증 사진, 얼굴정보(원본정보)
                        </div>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button
                        className={styles.btnAgree}
                        onClick={handleAgree}
                        disabled={!checked}
                    >
                        비대면 본인인증 진행
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConsentModal;
